module.exports = __webpack_public_path__ + "media/images/0309_questionnaire-2f1b29c96fc762a66071de91bbbf2680.png";